"use client";

import React, { useState } from "react";
import styles from "./technical-specifications.module.css";
import { ListingData } from "@/types/types";
import { IoChevronDownOutline, IoChevronUpOutline } from "react-icons/io5";

interface TechnicalSpecificationsProps {
  listingData: ListingData;
  defaultExpanded?: boolean; // Optional prop in case you want it open on Standard listings
}

export default function TechnicalSpecifications({
  listingData,
  defaultExpanded = false,
}: TechnicalSpecificationsProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  // Helper to format category/type text nicely
  const formatType = (str?: string | null) => {
    if (!str) return null;
    return str.charAt(0).toUpperCase() + str.slice(1).replace("-", " ");
  };

  // Build the array dynamically to avoid rendering empty rows
  const details = [
    {
      label: "ID proprietate",
      value: listingData.reference_id
        ? `#${listingData.reference_id}`
        : `#${listingData.listing_id.slice(0, 8)}`,
    },
    {
      label: "Tip clădire",
      value: formatType(listingData.building_type),
    },
    {
      label: "Regim înălțime",
      value: listingData.levels,
    },
    {
      label: "Structură",
      value: listingData.construction_materials,
    },
    {
      label: "Stare",
      value: listingData.new_development ? "Nou" : "Existent",
    },
    {
      label: "Lot",
      value: listingData.lot_size ? `${listingData.lot_size} mp` : null,
    },
    {
      label: "Comision cumpărător",
      value:
        listingData.buyers_fee !== undefined
          ? `${listingData.buyers_fee}%`
          : null,
    },
    {
      label: "Status",
      value: formatType(listingData.status),
    },
  ].filter((item) => item.value); // Strip out any details that are empty/null

  if (details.length === 0) return null;

  return (
    <div className={styles.container}>
      {/* Accordion Trigger */}
      <button
        className={styles.accordionHeader}
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <h2 className={styles.title}>Specificații tehnice</h2>
        <div className={styles.iconWrapper}>
          {isExpanded ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
        </div>
      </button>

      {/* Expandable Content */}
      <div
        className={`${styles.accordionContent} ${
          isExpanded ? styles.expanded : styles.collapsed
        }`}
      >
        {/* NEW: Inner wrapper required for the CSS Grid trick */}
        <div className={styles.accordionInner}>
          <div className={styles.grid}>
            {details.map((detail, index) => (
              <div key={index} className={styles.row}>
                <span className={styles.label}>{detail.label}</span>
                <span className={styles.value}>{detail.value}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
